'use-client';
import type { FC } from 'react';
import React from 'react';

import type { ILoginSocialBarProps } from '../LoginSocialBar.types';
import OldLoginSocialBar from './oldLoginSocialBar/OldLoginSocialBar';
import ResponsiveLoginSocialBar from './loginSocialBar/LoginSocialBar';

const LoginSocialBar: FC<ILoginSocialBarProps> = props => {
  if (props.enableCustomCSSVarsSupport) {
    return <ResponsiveLoginSocialBar {...props} />;
  }

  return <OldLoginSocialBar {...props} />;
};

export default LoginSocialBar;
